import {StyleSheet} from 'react-native';

export const GlossStyles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    backgroundColor: 'white',
    justifyContent: 'space-between',
    maxWidth: 870,
    marginHorizontal: 'auto',
    marginVertical: 20,
    width: '100%',
    paddingTop: 30,
    paddingBottom: 40,
  },
  pageTtl: {
    fontSize: 18,
    color: '#000',
    fontWeight: '700',
  },
  titre: {
    fontSize: 16,
    marginTop: 20,
    color: 'rgba(29, 92, 66, 1)',
    fontWeight: '700',
  },
  definition: {
    fontSize: 14,
    marginTop: 20,
  },
});
